<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="500px"
    @close="handleClose"
  >
    <el-form ref="cancelForm" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="取消原因" prop="cancelReason">
        <el-input
          v-model="form.cancelReason"
          type="textarea"
          :rows="4"
          maxlength="50"
          show-word-limit
          placeholder="请输入取消原因"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="btnLoading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { cancelTimePriorityTagApi } from '../../../../api/dispatchCenter.js';

export default {
    name: 'CancelTaskDialog',
    props: {
    /**
     * 控制弹窗显示/隐藏
     */
        visible: {
            type: Boolean,
            default: false
        },
        /**
     * 任务集合
     */
        tasks: {
            type: Array,
            default: () => []
        },
        /**
     * 弹窗标题
     */
        title: {
            type: String,
            default: '取消时效考核标识'
        }
    },
    data() {
        return {
            /**
       * 表单数据
       */
            form: {
                cancelReason: ''
            },
            btnLoading: false,
            /**
       * 表单验证规则
       */
            rules: {
                cancelReason: [
                    { required: true, message: '请输入取消原因', trigger: 'blur' },
                    { min: 3, message: '请输入3-50个字符', trigger: 'blur' }
                ]
            }
        };
    },
    computed: {
    /**
     * 控制弹窗显示/隐藏
     */
        dialogVisible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit('update:visible', val);
            }
        }
    },
    methods: {
    /**
     * 关闭弹窗时的处理
     */
        handleClose() {
            this.$emit('update:visible', false);
        },
        /**
     * 点击确定按钮的处理
     */
        handleConfirm() {
            this.$refs.cancelForm.validate((valid) => {
                if (valid) {
                    try {
                        this.btnLoading = true;
                        const params = {
                            taskNoList: this.tasks.map(v => v.taskNo),
                            cancelReason: this.form.cancelReason
                        };
                        cancelTimePriorityTagApi(params).then((res) => {
                            if (res && +res.code === 0) {
                                this.$message.success('取消成功');
                                this.$emit('confirm');
                            }
                        }).catch(() => {
                        }).finally(() => {
                            this.btnLoading = false;
                        });
                    } catch (e) {
                        this.btnLoading = false;
                    }
                }
            });
        }
    }
};
</script>

<style scoped>

</style>
